import { ConditionIcon } from "entities/wheel-raffle";
import type { TabItem } from "shared/ui";

export type PeopleTab = "participants" | "winners";

// Счётчик в подписи; null — число неизвестно, показываем без него.
const withCount = (label: string, count: number | null) =>
  count === null ? label : `${label} (${count})`;

// До розыгрыша вкладка победителей не нужна: бэк отвечает 409.
export const getPeopleTabs = (
  isDrawn: boolean,
  participants: number,
  winners: number | null,
): TabItem<PeopleTab>[] => {
  const participantsTab: TabItem<PeopleTab> = {
    value: "participants",
    label: withCount("Participants", participants),
    icon: <ConditionIcon name="people" size={20} />,
  };
  if (!isDrawn) return [participantsTab];
  const winnersTab: TabItem<PeopleTab> = {
    value: "winners",
    label: withCount("Winners", winners),
    icon: <ConditionIcon name="trophy" size={20} />,
  };
  return [winnersTab, participantsTab];
};
